import {
    HttpClient, HttpHeaders, HttpParams, HttpUrlEncodingCodec
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, shareReplay, tap } from 'rxjs';
import { AuthToken } from 'src/app/core/models/auth-token.model';
import { UserSessionService } from 'src/app/core/services/user-session/user-session.service';

import { environment } from '../../../../environments/environment';

const URLS = {
    token: `${environment.apiUrl}/api/sso/token`,
    ssoURL: environment.sso.auth_url
};

@Injectable({
    providedIn: 'root'
})
export class SSOService {
    constructor(
        private session: UserSessionService,
        private http: HttpClient
    ) {

    }

    static getSSOUrl() {
        return URLS.ssoURL;
    }

    static getTokenUrl() {
        return URLS.token;
    }

    public getAuthToken(authorizationCode: string, redirectUri: string): Observable<AuthToken> {
        return this.getAccessToken(authorizationCode, redirectUri).pipe(
            tap((res) => {
                this.saveAuthToken(res);
                this.session.isSSOLogin = true;
            })
        );
    }

    private saveAuthToken(authToken: AuthToken) {
        this.session.token = authToken;
        this.session.setIsLoggedIn(true);
        localStorage.setItem('keycloak', JSON.stringify(authToken));
    }

    public getAccessToken(authorizationCode: string, redirectUri: string): Observable<AuthToken> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/x-www-form-urlencoded',
        });

        const body = new HttpParams({ encoder: new HttpUrlEncodingCodec() })
            .set('grant_type', 'authorization_code')
            .set('code', authorizationCode)
            .set('client_id', 'account')
            .set('redirect_uri', redirectUri)
            .set('user_experience', 'web');

        return this.http.post<AuthToken>(SSOService.getTokenUrl(), body.toString(), { headers })
            .pipe(shareReplay(), (err) => err);
    }
}
